
import { defineComponent, onMounted, onUnmounted, onUpdated, ref } from 'vue';
import LoaderComponent from './modules/common/components/loader-component.vue';
import { LoaderStore } from './store/loader.store';
import { AuthTokenTimestamp } from './utils/auth-valid.util';
import { RefreshAuthService } from "@/services/refresh-auth.service";
export default defineComponent({
  name: 'App',
  components: {
    LoaderComponent
  },
  computed: {
    load(): boolean {
      return LoaderStore.state.load;
    }
  },
  setup() {
    const isAcceptor = AuthTokenTimestamp(true);
    const isUser = AuthTokenTimestamp();
    const authIntervalId = ref<number>(-1);
    const clearAuthIntervalId = () => {
      clearInterval(authIntervalId.value);
    };
    const checkAuth = () => {
      const service = new RefreshAuthService();
      if (isAcceptor) {
        service.AcceptorAuth();
        return;
      }
      service.UserAuth();
    };
    const checkAuthEvery = (x = 15000) => {
      if (authIntervalId.value != -1) {
        clearAuthIntervalId();
      }
      if (isAcceptor || isUser) {
        authIntervalId.value = setInterval(checkAuth, x);
      }
    };
    onUnmounted(clearAuthIntervalId);
    onMounted(checkAuthEvery);
    onUpdated(checkAuthEvery);
  }
});
